import { REBOOKS_VIEW_ENABLED } from './types';

// In the browser console: rebooksView = true
export const REBOOKS_CONSOLE_PARAM = 'rebooksView';

const REBOOKS_VIEW_CHANGE_EVENT = 'rebooks-view-change';

let consoleParamInstalled = false;

function isEnabledValue(value: unknown) {
    return value === true || value === 'true' || value === 1 || value === '1';
}

function readStoredFlag() {
    try {
        return isEnabledValue(window.localStorage.getItem(REBOOKS_CONSOLE_PARAM));
    } catch {
        return false;
    }
}

function writeStoredFlag(enabled: boolean) {
    try {
        if (enabled) {
            window.localStorage.setItem(REBOOKS_CONSOLE_PARAM, 'true');
        } else {
            window.localStorage.removeItem(REBOOKS_CONSOLE_PARAM);
        }
    } catch {
        // localStorage can be unavailable in private mode.
    }
}

export function isRebooksViewEnabled() {
    if (REBOOKS_VIEW_ENABLED) {
        return true;
    }

    if (typeof window === 'undefined') {
        return false;
    }

    return readStoredFlag();
}

export function installRebooksConsoleParam() {
    if (consoleParamInstalled || typeof window === 'undefined') {
        return;
    }

    consoleParamInstalled = true;

    const existing = Object.getOwnPropertyDescriptor(
        window,
        REBOOKS_CONSOLE_PARAM,
    );
    if (existing && !existing.configurable) {
        return;
    }

    Object.defineProperty(window, REBOOKS_CONSOLE_PARAM, {
        configurable: true,
        enumerable: true,
        get() {
            return readStoredFlag();
        },
        set(value: unknown) {
            writeStoredFlag(isEnabledValue(value));
            window.dispatchEvent(new Event(REBOOKS_VIEW_CHANGE_EVENT));
        },
    });
}

export function subscribeRebooksView(listener: () => void): () => void {
    if (typeof window === 'undefined') {
        return () => {
            // No browser event to detach.
        };
    }

    installRebooksConsoleParam();
    window.addEventListener(REBOOKS_VIEW_CHANGE_EVENT, listener);

    return () => {
        window.removeEventListener(REBOOKS_VIEW_CHANGE_EVENT, listener);
    };
}

installRebooksConsoleParam();
